import React from "react";
import PropTypes from "prop-types";
import "./explainWords.scss";


const ExplainWords = () => {
    const Horizontal = () => <div className='horizontalLine' />
    const data = [
        {
            id: 1, title: 'Giải thích từ ngữ',
            text:
                <>
                    <ul className="list">
                        <div className="itemWrap"><li /> <a href="#1">IOTLink</a> </div>
                        <div className="itemWrap"><li /> <a href="#2">Chúng tôi</a> </div>
                        <div className="itemWrap"><li /> <a href="#3">Bạn, Khách hàng, Quý khách</a> </div>
                        <div className="itemWrap"><li /> <a href="#4">Tổ chức</a> </div>
                        <div className="itemWrap"><li /> <a href="#5">Email</a> </div>
                        <div className="itemWrap"><li /> <a href="#6">Tài khoản</a> </div>
                        <div className="itemWrap"><li /> <a href="#7">File, Dữ liệu</a> </div>
                        <div className="itemWrap"><li /> <a href="#8">Dịch vụ</a> </div>
                    </ul>
                    <Horizontal />
                    <div id="1"><b>IOTLink</b></div>
                    <div> Công ty TNHH IOTLink, mã số thuế: 0314460230 được cấp Sở Kế hoạch và đầu tư thành phố Hồ Chí Minh lần đầu ngày 14/6/2017,
                        địa chỉ đăng ký kinh doanh tại B-10.01 Officetel, tòa nhà Sunrise CityView, 31 Nguyễn Hữu Thọ, phường Tân Hưng, quận 7, thành phố Hồ Chí Minh, Việt Nam. </div>

                    <div id="2"><b>Chúng tôi</b></div>
                    <div >IOTLink, Map4D, các chi nhánh, văn phòng đại diện, các đơn vị hạch toán phụ thuộc của IOTLink theo quy định pháp luật. </div>

                    <div id="3"><b>Bạn, Khách hàng, Quý khách</b></div>
                    <div> Là cá nhân hoặc tổ chức do bạn đại diện sử dụng dịch vụ IOTLink cung cấp theo quy định của pháp luật hiện hành.</div>


                    <div id="4"><b>Tổ chức</b></div>
                    <div>Là Pháp nhân, Doanh nghiệp, tổ chức đoàn thể chung khác. </div>

                    <div id="5"><b>Email</b></div>
                    <div> Là chữ viết tắt của từ "Electronic Mail" trong Tiếng Anh. Dịch sang Tiếng Việt có nghĩa là "Thư điện tử". Là phương tiện dùng để gửi hoặc nhận nội dung, trao đổi thông tin trên mạng internet.</div>

                    <div id="6"><b>Tài khoản</b></div>
                    <div>Là định danh mỗi khách hàng trên hệ thống của chúng tôi, tài khoản được đăng ký và kích hoạt qua email, email này thuộc quyền sử dụng hợp pháp của Bạn.
                        Tùy theo quy định từng dịch vụ, để có thể sử dụng dịch vụ, bạn phải có tài khoản trên website và thanh toán hợp lệ. Bạn chỉ có thể tạo được tối đa 01 tài khoản cho 01 địa chỉ email.
                        Thông tin tài khoản là do bạn tự nguyện kê khai và chịu hoàn toàn trách nhiệm đối với những thông tin này. </div>

                    <div id="7" ><b>File, Dữ liệu</b></div>
                    <div>Là tập tin được lưu trữ trong các thiết bị lưu trữ như đĩa cứng, đĩa mềm, USB, CD, DVD, các hệ thống lưu trữ điện toán đám mây, v.v. </div>

                    <div id="8"><b> Dịch vụ</b></div>
                    <div>Là những sản phẩm, dịch vụ liên quan đến Map4D được IOTLink cung cấp. </div>
                </>
        }

    ]
    return (
        <div className='explainWords'>
            {
                data.map((value, index) => {
                    return (
                        <React.Fragment key={value.id}>
                            <div className='titContent'>{value.title}</div>
                            <div className="text">
                                {value.text}
                            </div>
                        </React.Fragment>
                    )
                })
            }
        </div>
    );
};

ExplainWords.propTypes = {
};

export default ExplainWords;
